import AuthAPI from '../api/auth';
import BaseActionCableConnector from '../../shared/helpers/BaseActionCableConnector';
import { newMessageNotification } from 'shared/helpers/AudioNotificationHelper';
import { WP_PERSONAL_EVENTS } from 'dashboard/routes/dashboard/settings/inbox/channels/constant.js';

class ActionCableConnector extends BaseActionCableConnector {
  constructor(app, pubsubToken) {
    const { websocketURL = '' } = window.peasyConfig || {};
    super(app, pubsubToken, websocketURL);
    this.CancelTyping = [];
    this.events = {
      'message.created': this.onMessageCreated,
      'message.updated': this.onMessageUpdated,
      'conversation.created': this.onConversationCreated,
      'conversation.status_changed': this.onStatusChange,
      'user:logout': this.onLogout,
      'page:reload': this.onReload,
      'assignee.changed': this.onAssigneeChanged,
      'conversation.typing_on': this.onTypingOn,
      'conversation.typing_off': this.onTypingOff,
      'conversation.contact_changed': this.onConversationContactChange,
      'presence.update': this.onPresenceUpdate,
      'contact.deleted': this.onContactDelete,
      'contact.updated': this.onContactUpdate,
      'conversation.mentioned': this.onConversationMentioned,

      // shop app action cable hook
      // pending: 1, cancelled: 2, packed: 3, out_for_delivery: 4, refunded: 5, completed: 6, paid: 7, created
      'order.pending': this.onOrderPending,
      'order.cancelled': this.onOrderCancelled,
      'order.packed': this.onOrderPacked,
      'order.out_for_delivery': this.onOrderOutForDelivery,
      'order.refunded': this.onOrderRefunded,
      'order.completed': this.onOrderCompleted,
      'order.paid': this.onOrderPaid,
      'order.collected': this.onOrderCollected,
      'order.created': this.onOrderCreated,
      'order.missed': this.onOrderMissed,

      'order.delivered': this.onDeliveryEventCreated,
      'delivery.event.created': this.onDeliveryEventCreated,
      'delivery.draft_failed': this.onDeliveryEventCreated,
      'delivery.created': this.onDeliveryEventCreated,

      // register verification
      'user.confirmed': this.onRegWhatsappVerify,

      // whatsapp inbox create QR code scan
      whatsapp_personal_connected: this.onWhatsappPersonalConnected,
      incoming_call: this.onCallChannelReceive,
      call_cancelled: this.onCallChannelReceive,
    };

    // call events
    this.callEvents = {
      call_channel_handler: this.onCallChannelReceive,
      // 'incoming_call': this.onIncomingCall,
      // 'call_error': this.onCallErr,
    };
  }

  isAValidEvent = data => {
    return this.app.$store.getters.getCurrentAccountId === data.account_id;
  };

  onMessageUpdated = data => {
    this.app.$store.dispatch('updateMessage', data);
  };

  onPresenceUpdate = data => {
    this.app.$store.dispatch('contacts/updatePresence', data.contacts);
    this.app.$store.dispatch('agents/updatePresence', data.users);
    this.app.$store.dispatch('setCurrentUserAvailability', data.users);
  };

  onConversationContactChange = payload => {
    const { meta = {}, id: conversationId } = payload;
    const { sender } = meta || {};
    if (conversationId) {
      this.app.$store.dispatch('updateConversationContact', {
        conversationId,
        ...sender,
      });
    }
  };

  onAssigneeChanged = payload => {
    const { id } = payload;
    if (id) {
      this.app.$store.dispatch('updateConversation', payload);
    }
    this.fetchConversationStats();
  };

  onConversationCreated = data => {
    this.app.$store.dispatch('addConversation', data);
    this.fetchConversationStats();
  };

  onLogout = () => AuthAPI.logout();

  onMessageCreated = data => {
    newMessageNotification(data);
    this.app.$store.dispatch('addMessage', data);
  };

  onReload = () => window.location.reload();

  onStatusChange = data => {
    this.app.$store.dispatch('updateConversation', data);
    this.fetchConversationStats();
  };

  onTypingOn = ({ conversation, user }) => {
    const conversationId = conversation.id;

    this.clearTimer(conversationId);
    this.app.$store.dispatch('conversationTypingStatus/create', {
      conversationId,
      user,
    });
    this.initTimer({ conversation, user });
  };

  onTypingOff = ({ conversation, user }) => {
    const conversationId = conversation.id;

    this.clearTimer(conversationId);
    this.app.$store.dispatch('conversationTypingStatus/destroy', {
      conversationId,
      user,
    });
  };

  onConversationMentioned = data => {
    this.app.$store.dispatch('addMentions', data);
  };

  clearTimer = conversationId => {
    const timerEvent = this.CancelTyping[conversationId];

    if (timerEvent) {
      clearTimeout(timerEvent);
      this.CancelTyping[conversationId] = null;
    }
  };

  initTimer = ({ conversation, user }) => {
    const conversationId = conversation.id;
    // Turn off typing automatically after 30 seconds
    this.CancelTyping[conversationId] = setTimeout(() => {
      this.onTypingOff({ conversation, user });
    }, 30000);
  };

  fetchConversationStats = () => {
    bus.$emit('fetch_conversation_stats');
  };

  onContactDelete = data => {
    this.app.$store.dispatch(
      'contacts/deleteContactThroughConversations',
      data.id
    );
    this.fetchConversationStats();
  };

  onContactUpdate = data => {
    this.app.$store.dispatch('contacts/updateContact', data);
  };

  // shop app action to chat catalog
  onOrderPending = data => {
    this.onOrderUpdateHandle(data);
  };

  onOrderCancelled = data => {
    this.onOrderUpdateHandle(data);
  };

  onOrderPacked = data => {
    this.onOrderUpdateHandle(data);
    bus.$emit('actionCableEvent_DeliveryEvent', data);
  };

  onOrderOutForDelivery = data => {
    this.onOrderUpdateHandle(data);
  };

  onOrderRefunded = data => {
    this.onOrderUpdateHandle(data);
  };

  onOrderCompleted = data => {
    this.onOrderUpdateHandle(data);
    bus.$emit('actionCableEvent_DeliveryEvent', data);
  };

  onOrderPaid = data => {
    this.onOrderUpdateHandle(data);
  };

  onOrderCollected = data => {
    this.onOrderUpdateHandle(data);
    bus.$emit('actionCableEvent_DeliveryEvent', data);
  };

  onDeliveryEventCreated = data => {
    console.log(data, 'onDeliveryEventCreated');
    // update the status of the order based on the data,

    if (data.order_status) {
      this.onOrderUpdateHandle(data);
    }
    // then show a alert or popup modal
    bus.$emit('actionCableEvent_DeliveryEvent', data);
  };

  onOrderCreated = data => {
    // insert a new order
    this.app.$store.dispatch('orders/createOrder', data);
  };

  onOrderMissed = data => {
    console.log(data, 'onOrderMissed');
    bus.$emit('actionCableEvent_OrderMissed', data);
  };

  onOrderUpdateHandle = data => {
    const orderData = {
      order_id: data.id,
      payload: {
        order_status: data.order_status,
      },
    };
    console.log({ orderData });

    this.app.$store.dispatch('orders/UpdateOrderById', orderData);
  };

  onRegWhatsappVerify = data => {
    console.log('onRegWhatsappVerify = ', data);
    // this.app.$store.dispatch('conversation/addOrUpdateMessage', data);
    bus.$emit('WhatsAppVerificationBusEvent', data);
  };

  onWhatsappPersonalConnected = data => {
    console.log('onWhatsappPersonalConnected', data);
    bus.$emit(WP_PERSONAL_EVENTS.ON_QR_SCANED, data);
  };

  // *********************************
  //  Handle Call events
  // ***********************************

  onCallChannelReceive = data => {
    bus.$emit('onCallChannelReceiveEvent', data);
  };

  //  Terminate call method
  terminateCall(call_id) {
    if (this.callChannel) {
      // console.log('Terminating call via Action Cable', call_id);
      this.callChannel.perform('end_call', {
        id: call_id,
        pubsub_token: AuthAPI.getPubSubToken(),
      });

      // Optionally unsubscribe
      this.consumer.subscriptions.remove(this.callChannel);
      this.callChannel = null;
    } else {
      console.warn('No active call channel to terminate');
    }
  }

  rejectCall(call_id) {
    if (this.callChannel) {
      // console.log('Terminating call via Action Cable', call_id);
      this.callChannel.perform('reject_call', {
        id: call_id,
        pubsub_token: AuthAPI.getPubSubToken(),
      });

      // Optionally unsubscribe
      this.consumer.subscriptions.remove(this.callChannel);
      this.callChannel = null;
    } else {
      console.warn('No active call channel to terminate');
    }
  }

  unsubscribeCallChannel = () => {
    if (this.callChannel) {
      this.consumer.subscriptions.remove(this.callChannel);
      this.callChannel = null;
    }
  };

  // In your ActionCable service
  receiveIncomingCall = payload => {
    if (this.callChannel) {
      // console.log("📞 Sending receive_call event to server", payload);

      this.callChannel.perform('answer_call', {
        ...payload,
        pubsub_token: AuthAPI.getPubSubToken(),
      });
    } else {
      console.warn('⚠️ No active call channel to receive call on');
    }
  };

  sendAudioToBackend = payload => {
    if (this.callChannel) {
      // console.log("📞 Sending audio data", payload.audio?.length);

      this.callChannel.perform('send_audio', {
        ...payload,
        pubsub_token: AuthAPI.getPubSubToken(),
      });
    } else {
      console.warn('⚠️ No active call channel to receive call on');
    }
  };

  // end cable
}

export default {
  init() {
    if (AuthAPI.isLoggedIn()) {
      const actionCable = new ActionCableConnector(
        window.WOOT,
        AuthAPI.getPubSubToken()
      );
      return actionCable;
    }
    return null;
  },
};
